<ion-content>
  <app-global-page-header
    [title]="'functions.filtration.usagemode.title' | translate"
  >
    <div slot="end">
      <ion-button
        color="medium"
        fill="clear"
        shape="round"
        (click)="dismissModal()"
      >
        <i class="fa-solid fa-times"></i>
      </ion-button>
    </div>
  </app-global-page-header>

  <div class="p-4">
    <p
      class="my-2 mb-4 color-medium"
      [innerHTML]="'P0003607.esp.desinfection.esp' | translate | nl2Br"
    ></p>

    <div>
      <table
        class="table table-bordered"
        style="width: 100%; border-width: 2px !important"
      >
        <tr>
          <th class="fw-normal p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp11' | translate }}
          </th>
          <th class="fw-bold p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp12' | translate }}
          </th>
          <th class="fw-bold p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp13' | translate }}
          </th>
          <th class="fw-bold p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp14' | translate }}
          </th>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp21' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp22' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp23' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp24' | translate }}
          </td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp31' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp32' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp33' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp34' | translate }}
          </td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp41' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp42' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp43' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp44' | translate }}
          </td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp51' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp52' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ '-' }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003607.esp.desinfection.esp54' | translate }}
          </td>
        </tr>
      </table>
    </div>

    <p
      class="my-2 mb-4 color-medium"
      [innerHTML]="
        'P0003607.esp.desinfection.txt.' + getTemperatureType()
          | translate
          | nl2Br
      "
    ></p>
  </div>
</ion-content>
